// Color constants to replace deleted Chakra theme colors
// These map to Tailwind CSS variables defined in globals.css

export type HealthSeverity = 'critical' | 'alarm' | 'monitor' | 'healthy' | 'na';

export const colors = {
  health: {
    // Actual color values for charts (ECharts can't resolve CSS variables)
    critical: '#CC0000',      // Red
    alarm: '#FF891B',         // Orange
    monitor: '#F1BF42',       // Yellow
    healthy: '#11975D',       // Green
    na: '#01152B',            // Dark blue
    notAvailable: '#01152B',  // Alias for 'na'
  },
  healthCSS: {
    // CSS custom property references for DOM styling
    critical: 'hsl(var(--bg-critical))',
    alarm: 'hsl(var(--bg-alarm))',
    monitor: 'hsl(var(--bg-monitor))',
    healthy: 'hsl(var(--bg-healthy))',
    na: 'hsl(var(--bg-not-monitored))',
    notAvailable: 'hsl(var(--bg-not-monitored))',
  },
  primary: {
    50: 'var(--dm-primary-50)',
    100: 'var(--dm-primary-100)',
    200: 'var(--dm-primary-200)',
    300: 'var(--dm-primary-300)',
    400: 'var(--dm-primary-400)',
    500: 'var(--dm-primary-500)',
    600: 'var(--dm-primary-600)',
    700: 'var(--dm-primary-700)',
    800: 'var(--dm-primary-800)',
    900: 'var(--dm-primary-900)',
  },
  variant: {
    50: 'var(--dm-variant-50)',
    100: 'var(--dm-variant-100)',
    200: 'var(--dm-variant-200)',
    300: 'var(--dm-variant-300)',
    400: 'var(--dm-variant-400)',
    500: 'var(--dm-variant-500)',
    600: 'var(--dm-variant-600)',
    700: 'var(--dm-variant-700)',
    800: 'var(--dm-variant-800)',
    900: 'var(--dm-variant-900)',
  },
  neutral: {
    25: 'var(--dm-neutral-25)',
    50: 'var(--dm-neutral-50)',
    100: 'var(--dm-neutral-100)',
    200: 'var(--dm-neutral-200)',
    300: 'var(--dm-neutral-300)',
    400: 'var(--dm-neutral-400)',
    500: 'var(--dm-neutral-500)',
    600: 'var(--dm-neutral-600)',
    700: 'var(--dm-neutral-700)',
    800: 'var(--dm-neutral-800)',
    900: 'var(--dm-neutral-900)',
  },
  // Chart colors
  chart: {
    1: 'hsl(var(--chart-1))',
    2: 'hsl(var(--chart-2))',
    3: 'hsl(var(--chart-3))',
    4: 'hsl(var(--chart-4))',
    5: 'hsl(var(--chart-5))',
  },
  // Legacy colors for compatibility
  DMPrimaryColor: 'var(--dm-primary-500)',
  DMWhite: '#ffffff',
  black: '#000000',
  white: '#ffffff',
};
